import { NO_VALUE_PLACEHOLDER } from "../Containers/containerDisplay";

export { NO_VALUE_PLACEHOLDER };

/** What the list's Ship Date cell reads when the document carries no ship date. */
export const MISSING_SHIP_DATE_LABEL = "No ship date";

/** Shown on the review form when the bill has no ship date, which blocks the save. */
export const MISSING_SHIP_DATE_WARNING = "A ship date is required to save this bill of lading.";
